var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPkgIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#C0940F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9892 30.9167C14.0075 30.9109 9.16271 26.2447 9.16669 20.4931C9.17068 14.7415 14.022 10.0814 20.0036 10.0833C25.9853 10.0853 30.8334 14.7484 30.8334 20.5C30.8298 26.2556 25.975 30.919 19.9892 30.9167ZM11.3334 20.6792C11.3846 25.2638 15.2779 28.9474 20.0461 28.9229C24.8143 28.8982 28.6662 25.1745 28.6662 20.5896C28.6662 16.0047 24.8143 12.281 20.0461 12.2563C15.2779 12.2317 11.3846 15.9154 11.3334 20.5V20.6792ZM21.0834 25.7083H18.9167V23.625H21.0834V25.7083ZM21.0834 21.5417H18.9167V15.2917H21.0834V21.5417Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkgIssue);
export default __webpack_public_path__ + "static/media/pkgIssue.eba115109016a3a8d7d2ce5a9a35e951.svg";
export { ForwardRef as ReactComponent };